export default "__VITE_ASSET__BVKJc75C__"